
import { Options, Vue } from "vue-class-component";
import Button from "./Button.vue";
import Language from "./Language.vue";

@Options({
  components: {
    Button,
    Language,
  },
  props: {
    link: String,
    stateMenuNumber: Number,
    stateMenuFilter: String,
    stateMenuMenu: Number,
  },
})
export default class EventGuestHeader extends Vue {
  link!: string;
  stateMenuNumber!: string;
  stateMenuFilter!: number;
  stateMenuMenu!: string;
}
